var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconComponent,{tag:"component",staticClass:"inline-block fill-current",staticStyle:{"height":"1em","width":"1em"},attrs:{"role":"img"}})}
var staticRenderFns = []

export { render, staticRenderFns }